module.exports = __webpack_public_path__ + "img/logo.b043ac4f.png";